// Auffangseite fuer Adressen, die es nicht gibt.
//
// Vorher zeigte jede falsche Adresse (Tippfehler, alte Links wie /cars,
// veraltete Suchtreffer) nur Kopf- und Fussbereich mit einer leeren Flaeche
// dazwischen. Das sieht nach kaputter Seite aus. Jetzt gibt es eine
// Erklaerung und Wege zurueck.
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useI18n } from "../I18nProvider";
import "./styles.css";

export default function NichtGefunden() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const ort = useLocation();

  return (
    <section className="nicht-gefunden">
      <div className="container">
        <div className="ng-kasten">
          <i className="fas fa-car-burst ng-symbol" aria-hidden="true"></i>
          <p className="ng-code">404</p>
          <h1>{t("nf.titel")}</h1>
          <p className="ng-text">{t("nf.text")}</p>
          <p className="ng-adresse">
            <code>{ort.pathname}</code>
          </p>

          <div className="ng-knoepfe">
            <button type="button" className="btn" onClick={() => navigate("/")}>
              {t("nf.start")}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                navigate("/");
                setTimeout(
                  () =>
                    window.dispatchEvent(
                      new CustomEvent("automah:formular", { detail: "purchase" })
                    ),
                  120
                );
              }}
            >
              {t("nav_cta")}
            </button>
          </div>

          <p className="ng-hilfe">
            {t("nf.hilfe")}{" "}
            <a href="tel:+4917696084998">+49 176 96084998</a>
          </p>
        </div>
      </div>
    </section>
  );
}
